/**
 * Given an array of promises, returns a promise that resolves true if
 * at least one of the inner promises also resolves true.
 */
export default async (promises: Promise<boolean>[]) =>
  (await Promise.all(promises)).includes(true);
